import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';

export interface SegmentOption<T extends string | number> {
  value: T;
  /** Metin ya da ikon; ikon kullanılıyorsa `title` ile erişilebilir ad verilmeli. */
  label: ReactNode;
  /** İkon seçeneklerinde okunur ad (ipucu + ekran okuyucu). */
  title?: string;
}

export function SegmentedControl<T extends string | number>({
  value,
  options,
  onChange,
  className,
  ariaLabel,
}: {
  value: T;
  options: SegmentOption<T>[];
  onChange: (v: T) => void;
  className?: string;
  ariaLabel?: string;
}) {
  return (
    <div
      role="radiogroup"
      aria-label={ariaLabel}
      className={cn('border-border bg-bg-muted inline-flex rounded-md border p-0.5', className)}
    >
      {options.map((o) => (
        <button
          key={String(o.value)}
          type="button"
          role="radio"
          aria-checked={o.value === value}
          aria-label={o.title}
          title={o.title}
          onClick={() => onChange(o.value)}
          className={cn(
            'rounded px-3 py-1 text-sm transition-colors',
            o.value === value ? 'bg-bg-elevated text-fg shadow' : 'text-fg-muted hover:text-fg',
          )}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
